import { getCurrentInstance, watch } from 'vue'

export default function useDisappearable() {
  const instance = getCurrentInstance()

  if (!instance) {
    throw new Error('Could not get current component. Are you using this composable in the setup() function? And not called after an async operation?')
  }

  // Prefer an explicit disappearKey passed by the parent, falling back to the vnode key.
  const key = instance?.vnode?.props?.disappearKey || instance?.vnode?.key
  if (!key) {
    throw new Error('Could not get key from vnode. Are you using this composable in a component that got a key (or disappearKey) from its parent?')
  }

  const disappearableStore = useDisappearableStore()

  disappearableStore.addDisappearableKey(key)

  let disappearFunction = () => {}

  let isDisappearing = false

  watch(
    () => disappearableStore.toDisappear,
    async () => {
      if (disappearableStore.shouldDisappear(key) && !isDisappearing) {
        isDisappearing = true
        await disappearFunction()
        disappearableStore.markDisappeared(key)
      }
    }
  )

  return {
    onDisappear: (callback) => (disappearFunction = callback),
  }
}
